<template>
    <div>
        <CoreTwoColumnsRow>
            <template #left>
                <CoreBorderWrapper
                    class="flex-grow-1 flex-shrink-1 flex-basis-55"
                    :condensed="true"
                >
                    {{ $t('§eq_operator.contact_person') }}
                    {{ isFieldRequired('contact_person') }}
                </CoreBorderWrapper>
            </template>

            <template #right>
                <CoreStringInput
                    class="flex-grow-1 flex-shrink-1 flex-basis-45"
                    placeholder="§ui.placeholder_input_contact_person"
                    name="contact_person"
                    :condensed="true"
                    :disabled="clientStore.saving || isPlaceholder"
                    :validator="v$.contact_person"
                    v-model="clientStore.clientData.contact_person"
                />
            </template>
        </CoreTwoColumnsRow>

        <CoreTwoColumnsRow>
            <template #left>
                <CoreBorderWrapper
                    class="flex-grow-1 flex-shrink-1 flex-basis-55"
                    :condensed="true"
                >
                    {{ $t('§eq_operator.contact_email') }}
                    {{ isFieldRequired('contact_email') }}
                </CoreBorderWrapper>
            </template>

            <template #right>
                <CoreStringInput
                    class="flex-grow-1 flex-shrink-1 flex-basis-45"
                    placeholder="§ui.placeholder_input_contact_email"
                    name="contact_email"
                    :condensed="true"
                    :disabled="clientStore.saving || isPlaceholder"
                    :validator="v$.contact_email"
                    v-model="clientStore.clientData.contact_email"
                />
            </template>
        </CoreTwoColumnsRow>

        <CoreTwoColumnsRow>
            <template #left>
                <CoreBorderWrapper
                    class="flex-grow-1 flex-shrink-1 flex-basis-55"
                    :condensed="true"
                >
                    {{ $t('§eq_operator.phone') }}
                    &nbsp;&nbsp;&nbsp;
                    <span class="text-100 font-italic">
                        {{ $t('§eq_operator.optional') }}
                    </span>
                </CoreBorderWrapper>
            </template>

            <template #right>
                <CoreStringInput
                    class="flex-grow-1 flex-shrink-1 flex-basis-45"
                    placeholder="§ui.placeholder_input_phone"
                    name="phone"
                    :disabled="clientStore.saving || isPlaceholder"
                    :condensed="true"
                    :validator="v$.phone"
                    v-model="clientStore.clientData.phone"
                />
            </template>
        </CoreTwoColumnsRow>
    </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import rules from '../validationRules.js'
import { useClientStore } from '@/stores/client'
import CoreBorderWrapper from '@/components/core/CoreBorderWrapper.vue'
import CoreTwoColumnsRow from '@/components/core/CoreTwoColumnsRow.vue'
import CoreStringInput from '@/components/core/CoreStringInput.vue'

export default {
    name: 'InputsContactInfo',

    components: {
        CoreBorderWrapper,
        CoreTwoColumnsRow,
        CoreStringInput,
    },

    props: {
        isModal: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            v$: {},
            clientStore: useClientStore(),
        }
    },

    computed: {
        isPlaceholder() {
            return !!this.clientStore.clientData.is_dummy
        },

        isValid() {
            return !this.v$.$invalid
        },
    },

    watch: {
        isValid: {
            handler(newValue) {
                this.clientStore.isValidContactInfo = newValue
            },
            immediate: true,
        },
    },

    mounted() {
        this.$nextTick(() => {
            this.v$ = useVuelidate(rules(this.isModal), this.clientStore.clientData)
        })
    },
}
</script>
